export default class Observer {

    constructor () {

        this._eventsList = {};

    }

    subscribe(eventName, handler, context) {
        if (!handler) return;
        const event = this._eventsList[eventName] || (this._eventsList[eventName] = []);
        event.push({
            handler,
            context: context || this
        });
    }
    publish(eventName, ...restArguments) {
        if (!this._eventsList[eventName]) return;
        const event = [...this._eventsList[eventName]];
        const eventLength = event.length;
        let i, headerData;
        for(i = 0; i < eventLength; i++) {
            headerData = event[i];
            headerData.handler.apply(headerData.context, restArguments);
        }
    }

    unsubscribe(eventName, offHandler) {
        if (!this._eventsList[eventName]) return;
        if(offHandler) {
            this.deleteHandler(eventName, offHandler);
        } else {
            delete this._eventsList[eventName] ;
        }
    }

    deleteHandler(eventName, offHandler){
        let event = this._eventsList[eventName];
        this._eventsList[eventName] = event.filter( item => item.handler !== offHandler);
    }

};